export enum OSEStudentFacingSections {
  AdditionalGuidance = 'additional guidance',
  AssessmentOpportunity = 'assessment opportunity',
  Collaboration = 'collaboration',
  HomeLearningOpportunity = 'home learning opportunity',
  KeyIdeas = 'key ideas',
  SafetyPrecautions = 'safety precautions',
  ScienceNotebook = 'science notebook',
  AlternateActivity = 'alternate activity',
}
